const widgetsSelector = state => state.widgets;

const usersWidgetSelector = state => widgetsSelector(state).users;

export const usersTabValueSelector = state => {
  const usersWidget = usersWidgetSelector(state);
  return usersWidget ? usersWidget.tabValue : null;
};
